import { useHistory, useLocation } from "react-router-dom";

const keys = { searchTerm: "search_term", categoryIs: "category_is", genreIs: "genre_is" };
const positiveInteger = (value, fallback) => /^\d+$/.test(value || "") && Number.isSafeInteger(Number(value)) && Number(value) > 0 ? Number(value) : fallback;

// Keep one source of truth so filters survive reloads and Back/Forward. Apply
// related changes in one navigation, including the pagination reset.
export default function usePhysicalBooksFilters() {
    const history = useHistory();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const rowsPerPage = positiveInteger(params.get("rows"), 20);
    const page = positiveInteger(params.get("page"), 1);
    const navigate = (changes, resetPage = false) => {
        const next = new URLSearchParams(location.search);
        Object.entries(changes).forEach(([key, value]) => {
            if (value === "" || value === null || value === undefined) next.delete(key);
            else next.set(key, String(value));
        });
        if (resetPage) { next.delete("page"); next.delete("first_page"); }
        const query = next.toString();
        if (query !== params.toString()) history.push({ pathname: location.pathname, search: query ? `?${query}` : "", hash: location.hash });
    };
    return {
        page,
        rowsPerPage,
        firstPage: (page - 1) * rowsPerPage,
        searchTerm: params.get("search_term") || "",
        categoryIs: params.get("category_is") || "",
        genreIs: params.get("genre_is") || "",
        changeFilter: (key, value) => {
            if (keys[key]) navigate({ [keys[key]]: typeof value === "string" ? value.trim() : value }, true);
        },
        clearFilters: () => navigate({ search_term: "", category_is: "", genre_is: "" }, true),
        changePagination: ({ page: nextPage, rows, first }) => navigate({ page: nextPage + 1, rows, first_page: first }),
    };
}
